import dico from "../../../util/src/language/dico";
import { Home } from "../lights/Home";
import CurrentAthleteWidget from "./CurrentAthleteWidget";
import CurrentCategoryRankingWidget from "./CurrentCategoryRankingWidget";
import CurrentGroupWidget from "./CurrentGroupWidget";

import React from "react";
import TimerWidget from "./TimerWidget";

type WidgetConfig = {
  id: string;
  name: string;
  description: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
};

export const AVAILABLE_WIDGETS: WidgetConfig[] = [
  {
    id: "current-athlete",
    name: dico().widget.currentAthleteWidgetName,
    description: dico().widget.currentAthleteWidgetDescription,
    component: CurrentAthleteWidget,
  },
  {
    id: "category-ranking",
    name: dico().widget.categoryRankingWidgetName,
    description: dico().widget.categoryRankingWidgetDescription,
    component: CurrentCategoryRankingWidget,
  },
  {
    id: "current-group",
    name: dico().widget.currentGroupWidgetName,
    description: dico().widget.currentGroupWidgetDescription,
    component: CurrentGroupWidget,
  },
  {
    id: "lights",
    name: dico().widget.lightsWidget,
    description: dico().widget.lightsWidgetDescription,
    component: Home,
  },
  {
    id: "timer",
    name: dico().widget.timerWidget,
    description: dico().widget.timerWidgetDescription,
    component: TimerWidget,
  },
];
